module.exports = __webpack_public_path__ + "static/media/li.c0f4e698.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/li.svg
// module id = 2140
// module chunks = 0